import PageLayout from "@/components/aoria/PageLayout";
import Seo from "@/components/aoria/Seo";
import { ORG } from "@/lib/org";

export default function MentionsLegales() {
    return (
        <PageLayout testid="mentions-legales-page">
            <Seo
                title="Mentions légales · Aoria"
                description="Mentions légales d'Aoria, association déclarée loi 1901 consacrée à l'accessibilité cognitive. SIREN 993 013 549. Identité de l'éditeur, hébergeur, propriété intellectuelle."
                path="/mentions-legales"
            />
            <article className="max-w-3xl mx-auto px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
                <span className="eyebrow">Information légale</span>
                <h1 className="h1 mt-6 text-4xl md:text-5xl lg:text-6xl text-[#0D1B2A]">
                    Mentions légales
                </h1>
                <p className="mt-6 text-[#5C6B7D] leading-relaxed">
                    Conformément aux dispositions des articles 6-III et 19 de
                    la loi n° 2004-575 du 21 juin 2004 pour la confiance dans
                    l'économie numérique, les informations ci-dessous permettent
                    d'identifier l'éditeur et l'hébergeur du présent site.
                </p>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Éditeur du site
                    </h2>
                    <dl className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-4 border-y border-[#E0E1DD] py-6">
                        <dt className="eyebrow">Dénomination</dt>
                        <dd className="md:col-span-2 text-[#1B263B]">
                            {ORG.name}
                        </dd>
                        <dt className="eyebrow">Forme juridique</dt>
                        <dd className="md:col-span-2 text-[#1B263B]">
                            {ORG.form}
                        </dd>
                        <dt className="eyebrow">Siège social</dt>
                        <dd
                            data-testid="legal-address"
                            className="md:col-span-2 text-[#1B263B]"
                        >
                            {ORG.address.street}
                            <br />
                            {ORG.address.zip} {ORG.address.city}
                            <br />
                            {ORG.address.country}
                        </dd>
                        <dt className="eyebrow">SIREN</dt>
                        <dd
                            data-testid="legal-siren"
                            className="md:col-span-2 text-[#1B263B] font-mono tracking-wider"
                        >
                            {ORG.siren}
                        </dd>
                        <dt className="eyebrow">Contact</dt>
                        <dd className="md:col-span-2 text-[#1B263B]">
                            <a
                                href={`mailto:${ORG.email}`}
                                className="link-underline"
                            >
                                {ORG.email}
                            </a>
                        </dd>
                        <dt className="eyebrow">Directeur de publication</dt>
                        <dd className="md:col-span-2 text-[#1B263B]">
                            {ORG.publicationDirector}
                        </dd>
                    </dl>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Hébergement
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Le site <strong>aoria.org</strong> est hébergé par{" "}
                        <strong>{ORG.host.name}</strong>, {ORG.host.address}.
                        Site web :{" "}
                        <a
                            href={ORG.host.website}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="link-underline"
                        >
                            {ORG.host.website}
                        </a>
                        .
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Propriété intellectuelle
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        L'ensemble des contenus publiés sur ce site
                        (textes, identité visuelle, structure éditoriale,
                        illustrations originales) sont la propriété d'Aoria ou
                        de ses partenaires identifiés. Toute reproduction,
                        représentation ou diffusion, en tout ou partie, sans
                        autorisation préalable et écrite est interdite et
                        constituerait une contrefaçon sanctionnée par les
                        articles L. 335-2 et suivants du Code de la propriété
                        intellectuelle. Les citations courtes, sourcées et non
                        dénaturées sont libres dans les conditions prévues par
                        la loi.
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Responsabilité éditoriale
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Aoria publie des contenus à vocation éducative,
                        d'information et de plaidoyer autour de l'accessibilité
                        cognitive. Les analyses, prises de position et
                        ressources mises en ligne sont rédigées avec rigueur et
                        sourcées lorsque cela est pertinent ; elles ne
                        constituent ni un avis médical, ni un avis juridique,
                        ni un avis financier.
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Crédits
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Conception et développement du site : équipe d'Aoria.
                        Photographies et illustrations abstraites :
                        contributions originales et sources libres de droits
                        (Unsplash, Pexels) créditées à leurs auteurs.
                        Typographies : EB Garamond et Manrope (licences SIL Open
                        Font).
                    </p>
                </section>
            </article>
        </PageLayout>
    );
}
